import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ children, backTo }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="header">
      <button onClick={handleBack} className="back-button">
        &larr; Atras
      </button>
      <div className="header-actions" style={{     marginRight: '40px' }}>
        {children}
      </div>
    </div>
  );
};

export default Header; 